<template>
  <div>
    <div class="container">
      <a-card>
        <h3 style="margin-bottom: 20px;">
          Notifications
        </h3>
        <a-tabs default-active-key="notSeen">
          <a-tab-pane key="notSeen" tab="Unread">
            <NotificationAllList :variablesQuery="{ isViewed: false }" />
          </a-tab-pane>
          <a-tab-pane key="seen" tab="Read">
            <NotificationAllList
              :isClickAllViewed="false"
              :variablesQuery="{ isViewed: true }"
            />
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </div>
  </div>
</template>
<script>
import NotificationAllList from "./notificationTabs/NotificationAllList";

export default {
  components: { NotificationAllList },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="css" scoped>
.container {
  margin-top: 50px;
  padding: 2em;
}
</style>
